<div class="sticky-top">
  <app-header-home></app-header-home>
</div>
<div class="header-body"></div>
<div class="container-fluid">
  <div id="WrapperContent" class="col-12 col-xl-12">
    <div class="border-bottom px-5">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-2">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item"><a href="blog">Blog</a></li>
          <li class="breadcrumb-item"><a href="{{tipoPost}}s">{{tipoPost === 'noticia' ? "Noticias" : "Artículos"}}</a></li>
          <li class="breadcrumb-item active" aria-current="page"><a>{{post?.titulo}}</a></li>
        </ol>
      </nav>
    </div>
    <div class="clusterTitle mt-5 px-5">
      <h2>{{post?.titulo}}</h2>
      <div class="d-flex flex-row align-items-center mt-3">
        <div class="d-flex flex-column">
          <p class="m-0 title1">Categorías</p>
          <p class="text-uppercase m-0 title2">{{post?.categorias}}</p>
        </div>
      </div>
    </div>
    <div class="row px-5">
      <div class="col-12 col-xl-9">
        <img [src]="post?.imagen" alt="" class="img-fluid my-4">
        <div [innerHTML]="contenidoPost"></div>
        <div id="clusterCompartir" class="d-flex flex-row">
          <p class="m-0 mt-1">Comparte</p>
          <a [href]="enlaceFacebook" target="_blank">
            <img src="./assets/img/Ico_facebook.svg" alt="" class="img-ico-redes ms-2 mt-1 hvr-grow">
          </a>
          <a [href]="enlaceTwitter" target="_blank">
            <img src="./assets/img/Home/svg/Ico_twitter.svg" alt="" class="img-ico-redes ms-2 mt-1 hvr-grow">
          </a>
        </div>
      </div>
      <div class="col-12 col-xl-3">
        <div id="CardSidecardSinglePage" class="mt-4">
          <h6 class="mb-3">También te puede interesar</h6>
          <div class="line mb-4"></div>
          <div class="d-flex flex-column">
            @for (recomendado of listaRecomendados; track recomendado) {
              <div class="card mb-2" style="width: 15rem;">
                <img [src]="recomendado.imagen" alt="" class="card-img-top">
                <div class="card-body">
                  <p class="card-text mb-1">{{recomendado.fechaCreacion | date: "dd/MM/YYYY" }}</p>
                  <p class="card-title mb-1">{{recomendado.titulo}}</p>
                  <a href="#" [routerLink]="'/detalle/'+ tipoPost +'/'+ transformarTitulo(recomendado.titulo) +'/'+ recomendado.idNodo"
                  class="btn btn-primary hvr-shrink">Ver más</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer-body"></div>
<app-footer></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
